// src/components/resources/quizzes/QuizList.tsx

'use client'

import { useState } from 'react'
import ResourceGrid from '~/components/resources/ResourceGrid'
import { QuizFilters } from '~/components/resources/quizzes/QuizFilters'
import type { Quiz } from '~/lib/resources/types/tools/quiz'

interface QuizListProps {
  initialQuizzes: Quiz[]
}

export function QuizList({ initialQuizzes }: QuizListProps): JSX.Element {
  const [filteredQuizzes, setFilteredQuizzes] = useState<Quiz[]>(initialQuizzes)

  return (
    <div className="space-y-8">
      <QuizFilters
        quizzes={initialQuizzes}
        onFilter={setFilteredQuizzes}
      />

      {filteredQuizzes.length > 0 ? (
        <ResourceGrid resources={filteredQuizzes} />
      ) : (
        <div className="rounded-lg bg-white p-6 text-center shadow-sm ring-1 ring-gray-900/5 dark:bg-gray-800 dark:ring-white/10">
          <p className="text-gray-600 dark:text-gray-400">
            No quizzes match your filters. Try adjusting your search criteria.
          </p>
        </div>
      )}
    </div>
  )
} 